export const data = {
  githubUsername: "sahiljena",
  linkedin: "https://www.linkedin.com/in/sahil-jena/",
  twitter: "https://twitter.com/Sahiljena7",
  instagram: "https://www.instagram.com/sahiljena_/",
  codechef: "https://www.codechef.com/users/sahiljena",
  hackerrank: "https://www.hackerrank.com/sahiljena46?hr_r=1",
  leetcode: "https://leetcode.com/sahiljena/",
  education: [
    {
      name: "SRM IST",
      program: "B.Tech - Computer Science Engineering",
      duration: "2020-2024",
      score: "9.21   CGPA - 4th Semester",
      img: "https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2022/01/srm-logo-white.svg.gzip",
    },
    {
      name: "Ramjas School R.K Puram",
      program: "Class 12th",
      duration: "2019-2020",
      score: "",
      img: "https://ramjasschoolrkpuram.com/img/logo.png",
    },
  ],
  experience: [
    {
      name: "CryptoNaukri",
      designation: "Software Development Engineer - Intern",
      works: [
        "Worked with JavaScript, Node.js, React.js , TailWindCSS, MaterialUI to develop user dashboard Signup and login pages",
        "Bulit a secure user authentication on the frontend using JWT Tokens and Cookies",
        "Simplifed the onboarding system and decreased user onboarding time",
      ],
      duration: "Remote, March 2022 - June 2022",
    },
    {
      name: "Microsoft Learn Student Ambassadors SRM",
      designation: "Technical Associate ",
      works: [
        "Developed mass mailing scripts, to deliver important updates and certificates for events hosted by the club, used Python, Sendgrid API",
        "Built Discord Bot uisng Python (Discord.py) to schedule meetings for club's tasks using Google Calendar API",
      ],
      duration: "Chennai , October 2020 - current",
    },
  ],
  certificates: [
    {
      img: "https://i.ibb.co/qgTPJ2R/Screenshot-2022-11-25-195524.png",
      name: "AWS Academy Graduate - AWS Academy Cloud Operations",
      verification: "https://www.credly.com/go/DEmnm4NU",
    },
  ],
};
